import { chatRecords } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ChatRecordsSection() {
  return (
    <section id="records" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="聊天记录"
          title="按时间排好，一句都不会错位"
          desc="昵称与头像做遮挡处理，只保留与事件相关的对话、时间戳与撤回提示。"
          actionLabel="查看全部记录"
          actionHref="#overview"
        />

        <div className="relative">
          <div className="absolute bottom-2 left-[15px] top-2 w-px bg-background-300 md:left-[19px]" />
          <div className="flex flex-col gap-5">
            {chatRecords.map((item) => (
              <article key={item.id} className="relative pl-10 md:pl-14">
                <span className="absolute left-0 top-5 flex h-8 w-8 items-center justify-center rounded-full border border-background-300 bg-background-50 md:h-10 md:w-10">
                  <i className="ri-chat-3-line text-sm text-primary-600 md:text-base" />
                </span>
                <a
                  href="#overview"
                  className="group block rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-calendar-line" />
                      {item.time}
                    </span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-file-list-3-line" />
                      共 {item.lines} 条
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    展开截图
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}